<template>
  <DetailsPageTitle :title="$t('footer.contact')"></DetailsPageTitle>

  <ClientOnly>
    <div class="w-full md:h-64 h-120 auto-container px-4 md:px-unset">
      <l-map
        :use-global-leaflet="false"
        ref="map"
        v-model:zoom="zoom"
        :center="location"
      >
        <l-tile-layer
          :url="`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`"
          :options="{
            locale: locale,
          }"
          layer-type="base"
          name="OpenStreetMap"
          :min-zoom="8"
          :max-zoom="15"
        ></l-tile-layer>
        <l-marker :lat-lng="location">
          <l-popup>
            <div class="flex flex-col items-center gap-4">
              <h3 class="font-bold">Taze Express</h3>
              <button class="btn-primary btn-hover text-white">
                <a
                  :href="`https://maps.google.com/maps?daddr=${location.join(
                    ','
                  )}`"
                  target="_blank"
                  class="text-white flex gap-2"
                >
                  <i class="icon-mdi:directions w-4 h-4 flex flex-none"></i>
                  <span> Directions </span>
                </a>
              </button>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
  </ClientOnly>
  <div
    class="flex flex-wrap gap-4 justify-center w-full auto-container px-4 md:px-unset"
  >
    <div class="w-48 md:flex-1">
      <h3 class="p-3 text-sm border-b-4 border-primary">
        {{ $t('static.contact.locate') }}
      </h3>
      <div class="flex items-center gap-2 h-16">
        <em name="location" class="icon-mdi:map-marker flex-none flex"></em>

        <div class="flex-grow text-sm text-start">Baghdad, Yarmook</div>
      </div>
    </div>
    <div class="w-48 md:flex-1">
      <h3 class="p-3 text-sm border-b-4 border-primary">
        {{ $t('static.contact.call') }}
      </h3>
      <div class="flex items-center gap-2 h-16">
        <em name="phone" class="icon-mdi:phone flex-none flex"></em>

        <div class="flex-grow text-sm text-start">6601</div>
      </div>
    </div>
    <div class="w-48 md:flex-1">
      <h3 class="p-3 text-sm border-b-4 border-primary">
        {{ $t('static.contact.email') }}
      </h3>
      <div class="flex items-center gap-2 h-16">
        <em name="email" class="icon-mdi:mail flex-none flex"></em>

        <div class="flex-grow text-sm text-start">info@taza.iq</div>
      </div>
    </div>
    <div class="w-48 md:flex-1">
      <h3 class="p-3 text-sm border-b-4 border-primary">
        {{ $t('footer.follow_us') }}
      </h3>
      <div class="flex items-center gap-2 h-16">
        <NuxtLink
          href="https://www.instagram.com/Tazaexpressiq/"
          target="_blank"
        >
          <button class="btn-primary btn-hover">
            <i class="icon-fab:instagram flex flex-none text-lg"></i>
          </button>
        </NuxtLink>
        <NuxtLink to="https://www.facebook.com/tazaexpressiq/" target="_blank">
          <button class="btn-primary btn-hover">
            <i class="icon-fab:facebook flex flex-none text-lg"></i>
          </button>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();
const zoom = ref(13);

const location = ref<any>([33.302149, 44.3302698]);
</script>

<style lang="scss">
.leaflet-bottom {
  &.leaflet-right {
    display: none;
  }
}
.leaflet-container a {
  color: inherit;
  text-decoration: none;
}
</style>
